import { Building2, CheckCircle, UserCheck, UserX } from "lucide-react";
import { StatCard } from "@/components/shared/StatCard";
import type { DepartmentStatsSummary } from "@/features/departments/utils/department-tree";

interface DepartmentsStatsProps {
  stats: DepartmentStatsSummary;
}

export function DepartmentsStats({ stats }: DepartmentsStatsProps) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <StatCard
        label="إجمالي الدوائر"
        value={stats.total}
        sub="إجمالي الدوائر المطابقة"
        icon={Building2}
        accent="primary"
      />
      <StatCard
        label="يتطلب موافقة"
        value={stats.requiresApproval}
        sub="دوائر تتطلب موافقة في العرض الحالي"
        icon={CheckCircle}
        accent="accent"
      />
      <StatCard
        label="لها مدير فرعي"
        value={stats.withSubAdmin}
        sub="دوائر لها مدير فرعي في العرض الحالي"
        icon={UserCheck}
        accent="secondary"
      />
      <StatCard
        label="بدون مدير فرعي"
        value={stats.withoutSubAdmin}
        sub="دوائر بدون مدير فرعي في العرض الحالي"
        icon={UserX}
        accent="muted"
      />
    </div>
  );
}
